<template>
    <div class="modal-overlay breakupmodal">
        <div class="modal-dialog-breakup p-3" role="document">

            <div class="modal-content">
                <div class="modal-header justify-content-center mb-2 border-0">
                    <h5 class="modal-title text-align-center d-flex w-100 justify-content-between align-items-center">

                        <h2>PREMIUM BREAKUP</h2>
                        <span @click="emitClose()">
                            <img src="/images/close-logo.svg" class="close_icon" />
                        </span>
                    </h5>
                </div>
                <div class="breakup_header p-1 mb-2">
                    <div class="copy_CID mb-2">
                        <CopyToClipboard :label="'JID'" :copyValue="requestId" :checkValid="false" :hasLabel="true" :truncate="false"/>
                    </div>
                    <div v-if="selectedPlanData && selectedPlanData?.productDetails?.planOption?.planName" class="d-flex align-items-center plan_name-content">
                        <span class="mb-0"><img src="@/assets/images/plan-name.png" width="32" height="32"/> &nbsp;</span>
                        <span class="mb-0">{{selectedPlanData?.productDetails?.planOption?.planName?.toUpperCase()}}</span>
                    </div>
                </div>
                <div class="modal-body mt-2">
                   <!-- base cover -->
                   <h3 style="font-size: 14px; text-align: left;">Base Cover</h3>
                    <div class="d-flex justify-content-between align-items-center mb-2 "
                        v-if="isValidInput(selectedPlanData?.productDetails?.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue)">
                        <div class="d-flex justify-content-between w-100 gap-2 ">
                            <p class="text-left" style="text-align: left;">Basic Own Damage Premium</p>
                            <h6>₹ {{
                                currency(selectedPlanData?.productDetails?.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue)
                                }} </h6>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-2 "
                        v-if="isValidInput(selectedPlanData?.productDetails?.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue)">
                        <div class="d-flex justify-content-between w-100 gap-2">
                            <p class="text-left" style="text-align: left;">Basic Third Party Premium</p>
                            <h6>₹ {{
                                currency(selectedPlanData?.productDetails?.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue)
                                }}</h6>
                        </div>
                    </div>
                    <template v-for="addons in this.filteredBasicAddon" :key="addons.optionSelected">
                        <div class="d-flex justify-content-between w-100 gap-2 mb-2 " v-if="!(selectedPlanData?.insuranceAndProducts?.productCode=='RGI4WOD' && addons?.optionSelected=='tppd')">
                            <p class="text-left" style="text-align: left;">
                                {{ addons.optionDescription }}
                                <span v-if="addons.optionSelected == 'paCvr'" class="si_value">(SI ₹ 15,00,000)</span>
                                <span v-else-if="addons?.optionSelected=='tppd' && selectedPlanData?.insuranceAndProducts?.motorProductType=='4W-Pvt'" class="si_value">(SI ₹ 7,50,000)</span>
                                <span v-else-if="addons?.optionSelected=='tppd' && selectedPlanData?.insuranceAndProducts?.motorProductType=='2W-Pvt'" class="si_value">(SI ₹ 1,00,000)</span>
                                <span v-else-if="addons.optionValue.length == 1 && addons.optionValue[0].optionValueInput != 0 && addons.optionSelected != 'tpCngCvr'" class="si_value">
                                (SI ₹ {{ formatIndianCurrency(addons.optionValue[0].optionValueInput) }})
                                </span>
                            </p>
                            <h6 v-if="breakupShowAddonPremiumAmount(addons)">₹ {{
                                currency(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue)
                            }}</h6>
                            <h6 v-else-if="breakupShowAddonIncludedInPlan(addons)">Included in Plan</h6>
                        </div>
                    </template>
                    <hr>
                    <!-- Addons-->
                    <h3 style="font-size: 14px; text-align: left;" v-if="shouldShowAddons(this.filteredAddonsbreakup)">
                        Addons</h3>
                    <div class="">
                        <template v-for="addons in this.filteredAddonsbreakup" :key="addons.optionSelected">
                            <div class="d-flex justify-content-between w-100 gap-2 mb-2 ">
                                <p class="text-left" style="text-align: left;">{{ addons.optionDescription }}</p>
                                <h6 v-if="breakupShowAddonPremiumAmount(addons)">₹ {{
                                    currency(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue)
                                }}</h6>
                                <h6 v-else-if="breakupShowAddonIncludedInPlan(addons)">Included in Plan</h6>
                            </div>
                        </template>
                        <hr v-if="shouldShowAddons(this.filteredAddonsbreakup)" >
                          <!-- Accessories  -->
                     <h3 style="font-size: 14px; text-align: left;" v-if="this.filteredAccessories.length > 0">
                        Accessories</h3>
                    
                        <template v-for="addons in this.filteredAccessories" :key="addons.optionSelected">
                            <div class="d-flex justify-content-between w-100 gap-2 mb-2 ">
                                <p class="text-left" style="text-align: left;">{{ addons.optionDescription }} <span class="si_value" v-if="!(fuelType == 'cng' || fuelType == 'lpg') && addons.optionValue[0].optionValueInput">(SI ₹ {{ formatIndianCurrency(addons.optionValue[0].optionValueInput) }})</span></p>
                                <h6 v-if="breakupShowAddonPremiumAmount(addons)">₹ {{
                                     currency(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue)
                                }}</h6>
                                <h6 v-else-if="breakupShowAddonIncludedInPlan(addons)">Included in Plan</h6>
                            </div>
                        </template>
                        <hr  v-if="this.filteredAccessories.length > 0">
                        
                         <!-- discount -->
                         <h3 style="font-size: 14px; text-align: left;" v-if="selectedPlanData?.productDetails?.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue || (Voluntary_Deductible.length > 0 && isValidInput(Voluntary_Deductible[0].premiumForEachPolicyTerm[0]?.premiumForEachPPO[0]?.premiumForEachPPF[0]?.premiumValue) ) || applicableDiscount.length>0">Discounts</h3>
                        <div class="d-flex justify-content-between w-100 gap-2 mb-2 "
                            v-if="selectedPlanData?.productDetails?.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue">
                            <p class="text-left" style="text-align: left;">No-Claim Bonus <span class="si_value">({{String(this.selectedPlanData.productDetails.motorNCBPremium[0].nextNcbSlabDetails[0].nextNcbSlabApplicable).trim()}}%)</span>
                            </p>
                            <h6 class="discount-green">- ₹
                                {{ currency(selectedPlanData?.productDetails?.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue) }}
                            </h6>
                        </div>

                        <template v-for="(discount, index) in applicableDiscount" :key="index"
                            v-show="discount && (breakupShowDiscountPremiumAmount(discount) || breakupShowDiscountIncludedInPlan(discount))">
                            <div  class="d-flex justify-content-between w-100 gap-2 mb-2">
                                <p class="text-left" style="text-align: left;">
                                    {{ discount.optionDescription }} Discount
                                    <span v-if="discount.optionValue.length == 1 && discount.optionValue[0].optionValueInput != 0 && discount.optionSelected != 'payAsDrv'" class="si_value">
                                        (SI ₹ {{ currency(discount.optionValue[0].optionValueInput) }})
                                    </span>
                                    <span v-else-if="discount.optionValue.length == 1 && discount.optionValue[0].optionValueInput != 0" class="si_value">
                                        (SI {{ formatIndianCurrency(discount.optionValue[0].optionValueInput) }} km/yr)
                                    </span>
                                </p>
                                <h6 v-if="breakupShowDiscountPremiumAmount(discount)" class="discount-green">
                                    - ₹ {{ currency(discount?.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue) }}
                                </h6>
                                <h6 v-else-if="breakupShowDiscountIncludedInPlan(discount)" class="discount-green">Included in Plan</h6>
                            </div>
                        </template>

                        <hr v-if="selectedPlanData?.productDetails?.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue || (Voluntary_Deductible.length > 0 && isValidInput(Voluntary_Deductible[0].premiumForEachPolicyTerm[0]?.premiumForEachPPO[0]?.premiumForEachPPF[0]?.premiumValue))|| applicableDiscount.length>0  ">
                         <!-- Premium Details -->
                        <h3 style="font-size: 14px; text-align: left;">Premium Details</h3>
                        <div class="d-flex justify-content-between w-100 gap-2 mb-2 "
                            v-if="isValidInput(selectedPlanData?.productDetails?.totalPremiumDetails[0].totalPremiumValueBeforeTax)">
                            <p class="text-left" style="text-align: left; ">Package Premium</p>
                            <h6>₹ {{
                                currency(selectedPlanData?.productDetails?.totalPremiumDetails[0].totalPremiumValueBeforeTax)
                                }}</h6>
                        </div>
                        <div class="d-flex justify-content-between w-100 gap-2 mb-2 "
                            v-if="isValidInput(selectedPlanData?.productDetails?.totalPremiumDetails[0].totalTax)">
                            <p class="text-left" style="text-align: left; ">GST@18%</p>
                            <h6>₹ {{ currency(selectedPlanData?.productDetails?.totalPremiumDetails[0].totalTax) }}
                            </h6>
                        </div>
                        <div class="d-flex justify-content-between w-100 gap-2 mb-2 "
                            v-if="isValidInput(selectedPlanData?.productDetails?.totalPremiumDetails[0].totalPremiumWithTax)">
                            <p class="text-left" style="text-align: left; ">Final Premium (GST inc.)</p>
                            <h6 class="final-premium">₹
                                {{ formatToINR(selectedPlanData?.productDetails?.totalPremiumDetails[0].totalPremiumWithTax) }}
                            </h6>
                        </div>
                    </div>
                    <hr>
                    <div class="modal-footer footer-info-container">
                        <img  :src="selectedPlanData?.supportingData?.insCompanyLogo" alt="Bank Logo" class="quote-logo productImage" draggable="false"  />
                        <div class="idv-status" v-if="!['StandaloneTP(1)', 'StandaloneTP(3)', 'StandaloneTP(5)'].includes(selectedPlanData.insuranceAndProducts.policyType) && selectedPlanData.supportingData?.insuredDeclaredValue?.suggestedIDV">
                            <span class="idv-label">IDV Cover</span>
                            <span class="idv-amount" style="font-size: 14px;">
                                &#8377; {{ formatIndianCurrency(selectedPlanData.supportingData?.insuredDeclaredValue?.suggestedIDV) }}
                            </span>
                        </div>
                    </div>
                    <button type="button" class="btn commonButton close-button py-2 mt-3" @click="proceedToBuy()">Proceed to Buy</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CopyToClipboard from "../components/uiResuable/CopyToClipBoard.vue"
export default {
    name: "AmountBreakUpSQ",
    props: ['selectedPlanData', "requestId"],
    components: { CopyToClipboard },
    data() {
        return {
            applicableDiscount:[],
            userData:"",
            intervalId: null,
            filteredaddon: [],
            // processedAddons:[]
            filteredBasicAddon: [],
            filteredAddonsbreakup: [],
            filteredAccessories:[],
            Automobile_Association: [],
            Voluntary_Deductible: [],
            fuelType: ""
        }
    },
    mounted() {
        if(sessionStorage.getItem("userData")){
            this.userData = JSON.parse(sessionStorage.getItem("userData"));
            this.fuelType = this.userData.fuelType?.toLowerCase();
        }
        this.intervalId = setInterval(() => {
            if (this.selectedPlanData && this.selectedPlanData?.productDetails?.motorCovers) {
                this.filteredaddon = this.selectedPlanData.productDetails.motorCovers.filter(option => {
                    const isAllConditionsMet = option.inbuiltInPlan === "No" &&
                        option.mandatoryInProduct === "No" &&
                        option.premiumForEachPolicyTerm.every(term =>
                            term.premiumForEachPPO.every(ppo =>
                                ppo.premiumForEachPPF.every(ppf =>
                                    ppf.totalPremiumValue === 0 || ppf.totalPremiumValue === null
                                )
                            )
                        ) &&
                        option.premiumIncludedFlag === "No" || option.premiumIncludedFlag === "0";;
                    return !isAllConditionsMet;
                });
            }
            this.filteredBasicAddon = this.filteredaddon
            .filter((addon) => this.getPremiumBreakup.basic_cover.includes(addon.optionSelected))
            .filter((addon) => this.addonBreakupRowVisible(addon))
            .sort((a, b) => {
                const aIndex = this.getPremiumBreakup.basic_cover.indexOf(a.optionSelected);
                const bIndex = this.getPremiumBreakup.basic_cover.indexOf(b.optionSelected);
                return aIndex - bIndex;
            });
            this.filteredAddonsbreakup = this.filteredaddon.filter((addon) =>
                    this.getPremiumBreakup.Addons.includes(addon.optionSelected))
            .filter((addon) => this.addonBreakupRowVisible(addon))
            .sort((a, b) => {
                const aIndex = this.getPremiumBreakup.Addons.indexOf(a.optionSelected);
                const bIndex = this.getPremiumBreakup.Addons.indexOf(b.optionSelected);
                return aIndex - bIndex;
            });
            this.filteredAccessories= this.filteredaddon.filter((addon) =>
                    this.getPremiumBreakup.Accessories.includes(addon.optionSelected))
            .filter((addon) => this.addonBreakupRowVisible(addon))
            .sort((a, b) => {
                const aIndex = this.getPremiumBreakup.Accessories.indexOf(a.optionSelected);
                const bIndex = this.getPremiumBreakup.Accessories.indexOf(b.optionSelected);
                return aIndex - bIndex;
            });
            this.allDiscounts = this.filteredaddon.filter((addon) =>
                ["volDed", "autoasso", "antiThft", "payAsDrv"].includes(addon.optionSelected)
            );      
            this.applicableDiscount = [];
            this.allDiscounts.forEach(discount => {
                const matchingCover = this.selectedPlanData.productDetails.motorCovers.find(
                    cover => cover.optionSelected === discount.optionSelected
                );
                if (matchingCover) {
                    discount.premiumIncludedFlag = matchingCover.premiumIncludedFlag;
                    if (this.discountBreakupRowVisible(discount)) {
                        this.applicableDiscount.push(discount);
                    }
                }
            });
        }, 100);
    },

    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },

    methods: {
        premiumRound(amount){
            return Math.round(amount);
        },
        breakupAddonNumericPremium(addon) {
            const pv = addon?.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue;
            return Number(pv);
        },
        /** Matches multiQuote getPremiumIncludedFlag: "Yes" or string "1" only */
        isPremiumIncludedInPlanCover(cover) {
            return !!(cover && (cover.premiumIncludedFlag === 'Yes' || cover.premiumIncludedFlag === '1'));
        },
        breakupShowAddonPremiumAmount(addon) {
            const n = this.breakupAddonNumericPremium(addon);
            return !isNaN(n) && n > 0;
        },
        breakupShowAddonIncludedInPlan(addon) {
            return this.isPremiumIncludedInPlanCover(addon) && !this.breakupShowAddonPremiumAmount(addon);
        },
        breakupDiscountNumericPremium(discount) {
            const pv = discount?.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue;
            return Number(pv);
        },
        breakupShowDiscountPremiumAmount(discount) {
            const n = this.breakupDiscountNumericPremium(discount);
            return !isNaN(n) && n > 0;
        },
        breakupShowDiscountIncludedInPlan(discount) {
            return this.isPremiumIncludedInPlanCover(discount) && !this.breakupShowDiscountPremiumAmount(discount);
        },
        emitClose() {
            this.$emit('emitClose')
        },
        proceedToBuy() {
            this.$emit('getPolicydetails', this.selectedPlanData)
        },
        isValidInput(input) {
            const num = Number(input);

            if (!isNaN(num) && num !== 0) {
                return true;
            }
            return false;
        },
        currency(amt) {
            const tmpAmt = parseFloat(amt).toFixed(2);
            return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        shouldShowAddons(data) {
            return Array.isArray(data) && data.length > 0;
        },
        addonBreakupRowVisible(addon) {
            if (this.selectedPlanData?.insuranceAndProducts?.productCode === 'RGI4WOD' && addon?.optionSelected === 'tppd') {
                return false;
            }
            return this.breakupShowAddonPremiumAmount(addon) || this.isPremiumIncludedInPlanCover(addon);
        },
        discountBreakupRowVisible(discount) {
            return this.breakupShowDiscountPremiumAmount(discount) || this.isPremiumIncludedInPlanCover(discount);
        }
    },
    computed: {
        getPremiumBreakup() {
            return this.$store.state.configData && this.$store.state.configData.PREMIUM_BREAKUP ? this.$store.state.configData.PREMIUM_BREAKUP : {};
        }
    }
}
</script>
<style lang="scss">
@import "../assets/scss/components/modals.scss";

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    padding-top: 100px;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(5px);
    z-index: 10;
}

.modal-dialog-breakup {
    position: relative;
    background-color: #FFF;
    max-width: 370px;
    height: 480px;
    overflow-y: auto;
    min-width: 400px;
    border-radius: 12px;
    padding: 48px 12px 12px;
    .breakup_header{
        border: 1px solid $input-border !important;
        border-radius: 8px;
    }
    .copy_CID{
        background-color: $base-dark-text !important;;
        border-radius: 4px;
        span{
            font-size: 12px !important;
        }
    }
    .modal-content{
        .plan_name-content{
            p{
                font-size: 14px !important;
                    // font-weight: 600;
                &:first-child{
                }
            }
            span{
                font-size: 14px !important;
            }
        }
    }
}

.dark .modal-dialog-breakup {
    background: $header-dark-bg !important;

    *:not(.discount-green) {
        color: $heading-darkColor !important;
    }
    .discount-green{
        color: #00c658 !important;
    }
    .final-premium{
        color: $main-bg !important;
    }
    .si_value{
        color: $active !important;
    }
    .close_icon {
        filter: invert(1);
    }
    .copy_CID{
        background-color: $cardBackgroundDark !important;;
        border-radius: 4px;
        p{
            color: $main-bg !important;
        }
    }
}
</style>